import {
  MENU_REPORT_HISTORY_LIST_ROUTE,
  MENU_REPORT_HISTORY_PREVIEW_ROUTE,
} from "config/route-consts";
import { Redirect, Route, Switch } from "react-router-dom";
import ResponsibilityHistoryList from "./MenuReportHistoryList/MenuReportHistoryList";
import MenuReportHistoryPreview from "./MenuReportHistoryPreview/MenuReportHistoryPreview";

function RoleHistoryView() {
  return (
    <Switch>
      <Route
        key={MENU_REPORT_HISTORY_LIST_ROUTE}
        path={MENU_REPORT_HISTORY_LIST_ROUTE}
        render={(props: any) => {
          return <ResponsibilityHistoryList {...props} />;
        }}
      />
      <Route
        key={MENU_REPORT_HISTORY_PREVIEW_ROUTE}
        path={MENU_REPORT_HISTORY_PREVIEW_ROUTE}
        render={(props: any) => {
          return <MenuReportHistoryPreview {...props} />;
        }}
      />
      <Redirect to={MENU_REPORT_HISTORY_LIST_ROUTE} />
    </Switch>
  );
}

export default RoleHistoryView;
